export interface DataTableConfig {
  /** Whether table should allow to select rows. */
  selectable: boolean;
  /** Determines if it is possible to select multiple rows. */
  multiple: boolean;
  /** Time in milliseconds to throttle listener on resize event. */
  throttleTime: number;
  /** Whether to hide header row in table. */
  hideHeaderRow: boolean;

  /** Whether to hide select column in table. */
  hideSelect: boolean;

  /** Set true if table row should be draggable */
  draggable: boolean;

  /** Set true if table row should be sortable by dragging */
  dragSortingDisabled: boolean;

  /** Set true if table row should be draggable */
  isMultiDragging: boolean;

  /** Set true if table should be droppable */
  droppable: boolean;

  /** */
  menuButIcon: boolean;

  showDragIndicator: boolean;

  customGridColumns?: string;

  /** Whether to make header sticky */
  isHeaderSticky: boolean;

  /** Whether to display detail row. */
  displayDetailRow: boolean;
}

export const defaultDataTableConfig: DataTableConfig = {
  menuButIcon: true,
  showDragIndicator: false,
  dragSortingDisabled: true,
  droppable: false,
  isMultiDragging: false,
  draggable: false,
  hideSelect: false,
  hideHeaderRow: false,
  throttleTime: 100,
  multiple: true,
  selectable: false,
  isHeaderSticky: false,
  displayDetailRow: false,
};
